var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.description)?_c('div',{staticClass:"pb-3",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e(),_vm._l((_vm.identifiers),function(id){return [_c('ds-identifier-chip',{key:id,attrs:{"identifier":id,"can-remove":_vm.canRemove && !_vm.isReadOnly},on:{"remove":_vm.remove}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }